import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, } from 'antd';
import { XPagination, } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, } from '@/components/TableCell';


class RateTable extends React.PureComponent {
    columns = () => [
        {
            title: '设置项',
            dataIndex: 'settingName',
            key: 'settingName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '比例(%)',
            dataIndex: 'ratio',
            key: 'ratio',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'enabledM',
            key: 'enabledM',
            align: 'center',
            width: '9%',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '说明',
            dataIndex: 'remark',
            key: 'remark',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this.tableAction(id, record)
        }
    ];

    //操作
    tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(record.settingName, 'historical')}>历史记录</div>
            </div >
        );
    };

    // 解析表格数据
    _takeDataSource = (data = []) => {
        // 解析表格数据，使符合columns格式要求
        return data.map(item => {
            item.enabledM = item.enabled == '1' ? '已生效' : item.enabled == '0' ? '未生效' : '';
            return item;
        });
    }


    render() {
        const { paginationChange } = this.props;
        const { dataList, pageSize, pageNum, resultTotal } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ x: 'max-content', y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

RateTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default RateTable;